export default __webpack_public_path__ + "static/media/DAIF_Extra3_Screen1_in.a5c9b057.mp4";